import React from 'react';
import { SegmentedControl } from '@ofself/shell';
import './Segmented.css';

// THE SEGMENTED STRIP — the house's one choice of view or value: a page's
// filters, its tabs, a setting's values, a sheet's mode, the corner's Cards |
// Rows. One frame, the parts side by side on hairline seams, the chosen one
// tinted in the layer's hue. It is the kit's SegmentedControl (a radio group,
// the arrows moving the choice), in Nucleus's size and type.
//
//   <Segmented label="Show" options={[{ id: 'all', label: 'All', count: 12 }, …]} value={v} onChange={setV} />
//
// An option is { id (or value), label, icon?, count?, hot?: 'warn' | 'live', title? },
// or a plain string. `iconOnly` keeps the words for the ear alone. `size` is
// 'sm' (a rail's aside), 'md' (the default) or 'lg' (the corner's 32).
// `fill` stretches the parts across the width. `multiple` takes and gives a
// list: each part is pressed on or off on its own (a filter of several).
// `stacked` sets each count under its word, for a narrow strip with long counts.

const idOf = (o) => (typeof o === 'string' ? o : o.id ?? o.value);

function Face({ o, iconOnly }) {
    if (typeof o === 'string') return o;
    const count = o.count != null && o.count !== '' ? o.count : null;
    return (
        <span className="nx-seg__face" title={o.title || (iconOnly ? o.label : undefined)}>
            {o.icon && <span className="nx-seg__glyph" aria-hidden="true">{o.icon}</span>}
            <span className={iconOnly && o.icon ? 'nx-seg__word is-hidden' : 'nx-seg__word'}>{o.label}</span>
            {count != null && <span className={`nx-seg__count${o.hot ? ` is-hot is-${o.hot}` : ''}`}>{count}</span>}
        </span>
    );
}

export default function Segmented({
    options, value, onChange, label, size = 'md', fill = false, iconOnly = false, multiple = false, stacked = false, className = '',
}) {
    // `stacked`: the count under the word, for a narrow strip whose counts are long (a rail's)
    const cls = `nx-seg is-${size}${fill ? ' is-fill' : ''}${iconOnly ? ' is-icons' : ''}${stacked ? ' is-stacked' : ''}${className ? ` ${className}` : ''}`;
    if (multiple) {
        const on = Array.isArray(value) ? value : [];
        return (
            <div className={`ofself-segmented ${cls}`} role="group" aria-label={label}>
                {options.map((o) => {
                    const id = idOf(o);
                    const lit = on.includes(id);
                    return (
                        <button key={String(id)} type="button" aria-pressed={lit} className={`ofself-segmented__opt${lit ? ' is-active' : ''}`}
                            onClick={() => onChange(lit ? on.filter((x) => x !== id) : [...on, id])}>
                            <Face o={o} iconOnly={iconOnly} />
                        </button>
                    );
                })}
            </div>
        );
    }
    // the kit keys its parts by string; the ids go back out as they came in
    const byKey = new Map(options.map((o) => [String(idOf(o)), idOf(o)]));
    return (
        <SegmentedControl
            className={cls}
            aria-label={label}
            options={options.map((o) => ({ value: String(idOf(o)), label: <Face o={o} iconOnly={iconOnly} /> }))}
            value={value == null ? null : String(value)}
            onChange={(k) => onChange(byKey.get(k))}
        />
    );
}

export { Segmented };
